'use client';

export { default } from './useScrollTrigger';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/useScrollTrigger/index.js
// module id = 978
// module chunks = 25